<div mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div *ngIf="cooperation.id">Kooperation bearbeiten</div>
  <div *ngIf="!cooperation.id">Kooperation hinzufügen</div>
</div>
<div mat-dialog-close class="dialog-closer"></div>
<div mat-dialog-content>
  <div class="flex w-full">
    <div class="w-1/5 pr-2 border-r border-gray-400" *ngIf="cooperationForm.get('artist').value && cooperationForm.get('artist').value.id">
      <div class="text-lg text-gray-500">
        Termine, {{ cooperationForm.get('artist').value.name }}
      </div>
      <app-event [compact]="true" *ngFor="let event of (events$ | async)" [event]="event"></app-event>
      <div *ngIf="(events$ | async).length == 0">
        <em>Bisher keine Termine</em>
      </div>
    </div>
    <div class="w-1/5 pr-2 border-r border-gray-400" *ngIf="!cooperationForm.get('artist').value">
      <div class="text-lg text-gray-500">
        Termine
      </div>
      <em>Bitte erst Artist auswählen</em>
    </div>
    <div class="w-4/5 pl-2">
      <form [formGroup]="cooperationForm">
        <div class="flex flex-wrap -mx-2">
          <div class="w-full px-2">
            <label>Kunde</label>
            <input type="text" id="customer" class="styled dark" [matAutocomplete]="customerAutocomplete" formControlName="customer">
            <mat-autocomplete #customerAutocomplete [displayWith]="displayCustomerFn" (optionSelected)="cooperationForm.get('customer').setValue($event.option.value)">
              <mat-option *ngFor="let customer of (customers$ | async)?.results" [value]="customer">
                <span>{{ customer.companyDisplayName }} ({{ customer.companyName }})</span>
              </mat-option>
            </mat-autocomplete>
            <div *ngIf="cooperationForm.get('customer') as customer">
              <div *ngIf="customer.invalid && (customer.dirty || customer.touched)"
                   class="text-sm text-red-500">
                <div *ngIf="customer.errors.invalidProperty">Bitte Kunden auswählen</div>
              </div>
            </div>

            <div (click)="addCustomer()" class="text-primary font-bold cursor-pointer hover:underline">
              + Kunde hinzufügen
            </div>
          </div>

          <div class="w-full px-2">
            <label>Artist</label>
            <input type="text" class="styled dark" [matAutocomplete]="artistAutocomplete" formControlName="artist">
            <mat-autocomplete #artistAutocomplete [displayWith]="displayArtistFn" (optionSelected)="cooperationForm.get('artist').setValue($event.option.value)">
              <mat-option *ngFor="let artist of (artists$ | async)?.results" [value]="artist">
                <span>{{ artist.name }}</span>
              </mat-option>
            </mat-autocomplete>
            <div *ngIf="cooperationForm.get('artist') as artist">
              <div *ngIf="artist.invalid && (artist.dirty || artist.touched)"
                   class="text-sm text-red-500">
                <div *ngIf="artist.errors.invalidProperty">Bitte Artist auswählen</div>
              </div>
            </div>
          </div>

          <div class="w-full px-2">
            <label>Status</label>
            <select class="styled dark" formControlName="state">
              <option value="new">Neu</option>
              <option value="done">Abgeschlossen</option>
              <option value="draft">Entwurf</option>
            </select>
          </div>

          <div class="w-full px-2">
            <label>Doing zuordnen</label>
            <input type="text" class="styled dark" [matAutocomplete]="doingAutocomplete" formControlName="doing">
            <mat-autocomplete #doingAutocomplete [displayWith]="displayDoingFn">
              <mat-option *ngFor="let doing of (doings$ | async)" [value]="doing">
                <span>{{ displayDoingFn(doing) }}</span>
              </mat-option>
            </mat-autocomplete>
          </div>

          <div class="w-full px-2">
            <label>Titel (optional)</label>
            <input placeholder="Titel der Kooperation" type="text" class="styled dark" formControlName="name">
          </div>

          <div class="w-full px-2">
            <h4>Termine</h4>
            <div class="md:py-4 overflow-x-auto w-full">
              <div formArrayName="events" class="inline-block min-w-full shadow rounded-lg overflow-hidden">
                <table class="list-table condensed">
                  <tr class="header">
                    <th>Art</th>
                    <th>Doing</th>
                    <th>Deadline</th>
                    <th>Gage/KSK</th>
                    <th></th>
                  </tr>

                  <tr *ngFor="let ev of cooperationForm.get('events')['controls']; let i=index" [formGroupName]="i">
                    <td class="align-top">
                      <select class="styled dark" formControlName="type">
                        <option value="socialmedia">Social-Media</option>
                        <option value="model">Model</option>
                        <option value="tv">TV</option>
                        <option value="custom">Sonstiges</option>
                      </select>
                      <div *ngIf="ev.get('type') as type">
                        <div *ngIf="type.invalid && (type.dirty || type.touched)"
                             class="text-sm text-red-500">
                          <div *ngIf="type.errors.required">Bitte Typ angeben</div>
                        </div>
                      </div>
                    </td>
                    <td class="align-top">
                      <input placeholder="Titel" type="text" class="styled" formControlName="title" />
                      <div *ngIf="ev.get('title') as title">
                        <div *ngIf="title.invalid && (title.dirty || title.touched)"
                             class="text-sm text-red-500">
                          <div *ngIf="title.errors.required">Bitte Titel angeben</div>
                        </div>
                      </div>
                    </td>
                    <td class="align-top">
                      <input [matDatepicker]="deadlinePicker" type="text" *ngIf="ev.get('fullday').value" placeholder="Deadline" class="styled" formControlName="deadline" (click)="deadlinePicker.open()">
                      <mat-datepicker #deadlinePicker startView="year"></mat-datepicker>
                      <input placeholder="Deadline" *ngIf="!ev.get('fullday').value" type="text" (click)="picker.open()" class="styled" [ngxMatDatetimePicker]="picker" formControlName="deadline" />
                      <ngx-mat-datetime-picker [defaultTime]="[0,0,0]" [stepMinute]="15" #picker></ngx-mat-datetime-picker>
                      <div *ngIf="ev.get('deadline') as deadline">
                        <div *ngIf="deadline.invalid && (deadline.dirty || deadline.touched)"
                             class="text-sm text-red-500">
                          <div *ngIf="deadline.errors.required || deadline.errors.matDatetimePickerParse">Bitte Datum auswählen</div>
                        </div>
                      </div>
                      <mat-checkbox formControlName="fullday">Ganztägig</mat-checkbox>
                    </td>
                    <td class="align-top">
                      <div class="flex flex-wrap">
                        <div class="w-1/2">
                          <app-currency-input [disabled]="ev.get('fee').disabled" [value]="ev.get('fee').value" [currency]="ev.get('currency').value" (valueChanged)="ev.get('fee').setValue($event)" (currencyChanged)="ev.get('currency').setValue($event);"></app-currency-input>
                        </div>
                        <div class="w-1/2">
                          <select formControlName="socialContributionType" class="styled dark">
                            <option value="not_needed">Fällt nicht an</option>
                            <option value="included">Inklusive KSK</option>
                            <option value="in_transit">KSK als durchlaufender Posten</option>
                            <option value="not_included">Zuzüglich KSK</option>
                            <option value="paid_by_customer">Wird vom Kunden bezahlt</option>
                              <option value="paid_by_artist">Influencer führt ab</option>
                          </select>
                        </div>
                      </div>
                      <select class="styled dark" formControlName="accountingType">
                        <option [value]="null">Zahlungseinstellungen nicht überschreiben</option>
                        <option value="normal">Zahlung an Artist</option>
                        <option value="settlement">Zahlung an Lionflence</option>
                      </select>
                    </td>
                    <td>
                      <div (click)="deleteEvent(i);" class="text-xl text-red-500" title="Eintrag löschen">
                        <span class="iconify" data-icon="fluent:delete-28-regular"></span>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <a (click)="addEvent()" class="px-4 py-1 text-sm bg-blue-400 text-white rounded inline-block cursor-pointer">
              + Termin hinzufügen
            </a>
          </div>
        </div>
      </form>
    </div>
  </div>

</div>

<div mat-dialog-actions class="w-full">
  <div class="w-full text-right">
    <app-button [loading]="saving$ | async" (click)="save()" classes="py-2 px-4 rounded bg-blue-500 text-white cursor-pointer inline-block">
      Speichern
    </app-button>
  </div>
</div>
